import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Button from "@/components/button";

export const Route = createFileRoute("/auth/_layout/success")({
    component: ConfirmationPage,
});

function ConfirmationPage() {
    const { t } = useTranslation("auth");
    return (
        <>
            <div className="flex flex-col items-start gap-3 w-full pt-20">
                <h1 className="heading-1 mb-5">{t("success.title")}</h1>
                <img
                    src="/checkmark-2.svg"
                    alt={t("success.imageAlt")}
                    width={60}
                    height={60}
                    className="mb-6"
                />
                <p className="body mb-6">
                    {t("success.greatWorkPrefix")}
                    <br />
                    <strong>{t("success.publicMarketAccount")}</strong>
                </p>
                <div className="border-[#200A0A]  w-full border mt-3" />
                <div className="mt-20">
                    <p className="body mb-6">
                        {t("success.nextStepPrefix")}
                        <strong>{t("success.businessEmployerProfile")}</strong>
                    </p>
                    <Button variant="secondary" className="w-[320px]">
                        {t("success.continue")}
                    </Button>
                </div>
            </div>
        </>
    );
}
